import { makeStyles } from '@material-ui/core';

import { RiArrowDownSLine, RiNewsLine, RiQuestionLine } from '@remixicon/react';

import { Button, Skeleton } from '@backstage/ui';

import {
  ConfidenceLogoInverted,
  ConfidenceWebsiteButtonLink,
  FeatureFlagged,
  Hidden,
} from '@spotify/confidence-core-react';
import {
  AppAccountSwitcher,
  AppHeader,
  AppSearchBar,
} from '@spotify/plugin-confidence-app-react';

import { DemoModeChip } from '../DemoModeChip';
import { TrialChip } from '../TrialChip';

const useStyles = makeStyles({
  links: {
    display: 'flex',
    gap: 'var(--bui-space-0_5)',
  },
});

export const Header = () => {
  const classes = useStyles();

  return (
    <AppHeader.Root>
      <AppHeader.Brand
        to="/"
        icon={
          <ConfidenceLogoInverted aria-hidden="true" style={{ fontSize: 28 }} />
        }
        text="Confidence"
      />
      <FeatureFlagged with="trial-banner">
        <TrialChip />
      </FeatureFlagged>
      <DemoModeChip />
      <AppHeader.Search>
        <AppSearchBar />
      </AppHeader.Search>
      <AppHeader.Aux>
        <div className={classes.links}>
          <Hidden xsDown>
            <ConfidenceWebsiteButtonLink
              aria-label="Documentation"
              route="/docs"
              variant="tertiary"
              iconStart={<RiQuestionLine aria-hidden="true" />}
            />
          </Hidden>
          <Hidden smDown>
            <ConfidenceWebsiteButtonLink
              aria-label="Blog"
              route="/blog"
              variant="tertiary"
              iconStart={<RiNewsLine aria-hidden="true" />}
            />
          </Hidden>

          <AppAccountSwitcher>
            {({ selectedAccount, isLoading, isSwitching }) =>
              selectedAccount && !isLoading && !isSwitching ? (
                <Button
                  variant="tertiary"
                  iconEnd={<RiArrowDownSLine aria-hidden="true" />}
                >
                  {selectedAccount.displayName}
                </Button>
              ) : (
                <Skeleton height={32} width={100} />
              )
            }
          </AppAccountSwitcher>
        </div>
      </AppHeader.Aux>
    </AppHeader.Root>
  );
};
